import React, {Component} from 'react';
import Checkbox from "../../comum/components/Checkbox";
import { Row, Label } from "reactstrap";
import { observer } from "mobx-react/index";

@observer
export default class FiltroVisualizacaoCheck extends Component{

    constructor(props){
        super(props);
    }

    isThere(val, arr){
        return arr.indexOf(arr.find((item) => item == val.id))!==-1;
    }

    render(){
        return(
            <div className="secao">
                <Row className="secao--titulo">
                    <h2>{this.props.titulo}</h2>
                    {this.props.selecionarTudo && <Label className="btn-primary filtro-acao-botao" onClick={this.props.selecionarTudo}>Selecionar Tudo</Label>}
                    {this.props.limparTudo && <Label onClick={this.props.limparTudo} className="btn-primary filtro-acao-botao">Limpar Tudo</Label>}
                </Row>
                <Row>
                    { this.props.itens && this.props.itens.map((check, i) => (
                        <Checkbox  
                            key={i}
                            index={check}
                            valor={check}
                            ativo={this.isThere(check, this.props.itensAtivos)}
                            className={"filtro-visualizacao-ckeckbox"}
                            obrigatorio={this.isThere(check, this.props.itensRequeridos)}
                            onClick={this.props.onClickItem } />
                    ))}
                </Row>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/modules/comum/components/FiltroVisualizacaoCheck.js